<template>
    <div>
        <el-select v-model="value" placeholder="请选择角色">
            <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
            </el-option>
        </el-select>
    </div>
</template>

<script>
import prjSalesmanApi from '../../models/project_salesman'
import Utils from '@/lin/utils/util'

export default {
    props: {
        row: {
            type: Object,
            default: () => {},
        },
        item: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            value: -1,
            catch_change: false,
            options: [
                {value:0,label:'未验证'},
                {value:1,label:'验证通过'},
                {value:2,label:'管理员'},
                {value:-1,label:'未通过'},
            ]
        }
    },
    watch: {
        row(val, oldVal) {
            let ovalue = this.value;
            this.value = this.row[this.item.prop];
            if(ovalue != -1) {
                this.catch_change = true
            }
        },
        async value(val, oldVal) {
            if(this.catch_change) {
                try {
                    this.row[this.item.prop] = val
                    let data = Utils.deepClone(this.row)
                    delete data.project
                    delete data.salesman
                    const res = await prjSalesmanApi.edit(this.row.id, data)
                    if (res.error_code === 0) {
                        this.$message.success(`${res.msg}`)
                    }else{
                        this.catch_change = false;
                        this.value = oldVal
                    }
                } catch (error) {
                    console.log(error)
                    this.catch_change = false;
                    this.value = oldVal
                }
            }
            this.catch_change = true;
        }
    },
}
</script>
